<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.6665 0.667969L0.666504 8.66797M0.666504 0.667969L8.6665 8.66797" stroke="#ED4040" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
